"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.goToPaymentService = void 0;
const goToPaymentService = () => {
    const PAYMENT_ENDPOINT = window.paymentServiceClientUrl;
    if (!PAYMENT_ENDPOINT) {
        console.error('Payment service URL is not defined.');
        return;
    }
    window.location.assign(PAYMENT_ENDPOINT);
};
exports.goToPaymentService = goToPaymentService;
